import { CSidebarNav } from '@coreui/react-pro'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppSidebarNav } from './AppSidebarNav'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { APP_CONSTANTS } from 'src/consumer/constants'
import logoSmall from 'src/assets/logo_brand.png'
import { ThemeContext } from 'src/context/ThemeContext'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import navigation from '../_nav'
import { SuccessManagerSidebarItem } from './sidebar/SuccessManagerSidebarItem'
import {
  SidebarBrand,
  SidebarBrandImage,
  SidebarBrandText,
  StyledBusinessSidebar,
  StyledSidebarSimplebar,
} from './styledComponents'
import { selectSidebarShow, setSidebarShow } from '../reducers/layoutReducer'

const AppSidebar = () => {
  const navigate = useNavigate()
  const { theme } = useContext(ThemeContext)
  function navigateToBusinessHome() {
    navigate('/workplace')
  }
  const dispatch = useDispatch()
  const sidebarShow = useSelector(selectSidebarShow)

  const availableRoles = getAllRolesInBoolean()

  return (
    <StyledBusinessSidebar
      position="fixed"
      unfoldable={false}
      visible={sidebarShow && availableRoles.isBusinessCustomer}
      onVisibleChange={(visible) => {
        dispatch(setSidebarShow(visible))
      }}
      themeType={theme}
    >
      <SidebarBrand>
        <SidebarBrandImage
          onClick={navigateToBusinessHome}
          src={APP_CONSTANTS.APP_LOGO_LINK}
          alt="App Logo"
          onError={(e) => {
            e.target.src = logoSmall
          }}
        />
        <SidebarBrandText>AUMHUM</SidebarBrandText>
      </SidebarBrand>
      <CSidebarNav className="sidebar-nav">
        <StyledSidebarSimplebar>
          <nav className="sidebar-nav-section">
            <span className="sidebar-nav-label">Navigation</span>
            <AppSidebarNav items={navigation} />
          </nav>
        </StyledSidebarSimplebar>
      </CSidebarNav>
      <SuccessManagerSidebarItem data={undefined} themeType={theme} />
    </StyledBusinessSidebar>
  )
}

export default React.memo(AppSidebar)
